import { ValidationReason, ValidationStatus } from '../types';

// Validation matrix helper (for UI validation)
export const VALIDATION_RULES: Record<
  ValidationStatus,
  {
    requiresReason: boolean;
    requiresComment: boolean;
    typicalReasons: ValidationReason[];
  }
> = {
  confirmed: {
    requiresReason: false,
    requiresComment: false,
    typicalReasons: []
  },
  partially_confirmed: {
    requiresReason: false,
    requiresComment: true,
    typicalReasons: []
  },
  false_positive: {
    requiresReason: true,
    requiresComment: false, // recommended but not required
    typicalReasons: [
      'scope_exception',
      'wrong_entity_type',
      'retrieval_wrong_chunk',
      'definition_missed'
    ]
  },
  not_applicable: {
    requiresReason: true,
    requiresComment: false,
    typicalReasons: [
      'scope_exception',
      'wrong_entity_type',
      'outdated_doc',
      'temporal_mismatch'
    ]
  },
  needs_clarification: {
    requiresReason: true,
    requiresComment: false,
    typicalReasons: ['other', 'definition_missed']
  },
  duplicate: {
    requiresReason: true,
    requiresComment: false,
    typicalReasons: ['other']
  },
  accepted_risk: {
    requiresReason: true,
    requiresComment: true,
    typicalReasons: ['scope_exception', 'temporal_mismatch', 'other']
  }
};
